import React from 'react';
import Logo from '../../../../assets/images/logo.png';
import './Header.scss';

export const Header = () => (
  <header className="d-flex">
    <img alt="logo" src={Logo} className="logo" />
  </header>
);
